<template>
	<div class="referal">
		<Modal
			:show="showReferalForm"
			content_class="col-12 col-md-6 col-lg-5 col-xl-4 payment-modal"
		>
			<template slot="content">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">Refer Product</div>
						</div>
						<div
							class="close-modal f-r"
							@click="$store.commit('showReferalForm', false)"
						>
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div>
						<Form
							classBinding="row form-box"
							:ref="ReferProduct.forms.refer_product.name"
							:forms="ReferProduct.forms.refer_product.forms"
							:formData="ReferProduct.forms.refer_product.data"
						/>

						<div class="row">
							<div class="col-12">
								<div
									class="btn btn-primary btn-long"
									:disabled="loading"
									@click="
										sendReferal({
											ref: $refs[
												ReferProduct.forms.refer_product
													.name
											],
										})
									"
								>
									Refer Product
									<div class="lds-ring" v-show="loading">
										<div></div>
										<div></div>
										<div></div>
										<div></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
import refer_product from '../rsc/stores/refer-product.store';

export default {
	beforeCreate() {
		// Event.$emit("loader:show", true);
	},
	beforeDestroy() {
		this.$store.unregisterModule('refer_product');
	},
	created() {
		utils.registerModule('refer_product', refer_product, this.$store);

		Event.$on('refer:product', async (payload) => {
			this.$store.commit('showReferalForm', true);
			this.$store.commit('refered_product', payload);
			// await this.$store.dispatch('initializeFields')
		});
	},
	components: {
		Modal: () => import('../templates/others/modal'),
		Form: () => import('@/libs/clarks/components/form'),
	},
	data() {
		return {};
	},
	computed: {
		...mapGetters(['ReferProduct', 'showReferalForm', 'loading']),
	},
	methods: {
		...mapActions(['fetchIntermediaries', 'sendReferal']),
	},
	mounted() {
		utils.registerModule('refer_product', refer_product, this.$store);
		this.fetchIntermediaries();
	},
};
</script>

<style lang="less">
.referal {
}
</style>
